import {Injectable} from '@angular/core';
import {GeneralServicesImplService} from '../../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../../services/api/servers';
import {urls} from '../../../../services/api/urls';
import {Observable} from 'rxjs';
import {ProjectConstants} from '../../../project-constants';
import {ProviderModel} from 'src/models/ProviderModel';

@Injectable({
  providedIn: 'root'
})

export class DeltaVolumiService extends GeneralServicesImplService {
  constructor(http: HttpClient) {
    super(http);
  }

  baseUrl: string = servers.apiUrl + urls.deltaVolumi;
  baseUrlGrouped: string = servers.apiUrl + urls.deltaVolumiGrouped;
  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.deltaVolumi;

  private generateUrl(provider: ProviderModel, selectedUrl: string) {
    let currBaseUrl =  this.baseUrl;
    if (provider && provider.cod && provider.cod === 'DXC') {
      currBaseUrl = this.baseUrlGrouped;
    }
    return currBaseUrl + selectedUrl;
  }

  getPage(offset: any, filter?: any): Observable<any> {
    const url = this.generateUrl(filter.provider, this.LINKS.PAGE);
    const body =  filter ? JSON.stringify(filter) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getComparePage(offset: any, filter?: any): Observable<any> {
    const url = this.generateUrl(filter.provider, this.LINKS.COMPARE);
    const body =  filter ? JSON.stringify(filter) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  updateAllClaims(offset: any, provider: ProviderModel): Observable<any> {
    const url = this.generateUrl(provider, this.LINKS.UPDATE_ALL_CLAIMS);
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getNameGenerateCsv(offset, payload: any) {
    const url = this.baseUrl + this.LINKS.GENERATE_CSV;
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'text', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );

  }

  getNameGenerateXlsx(offset, payload: any, comparing: boolean) {
    const endpoint = comparing ? this.LINKS.GENERATE_COMPARISON_XLSX : this.LINKS.GENERATE_XLSX;
    const url = this.generateUrl(payload.provider, endpoint);
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'blob', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );

  }

  getDownloadCsv(nameCsv: string) {
    const url = this.baseUrl + this.LINKS.DOWNLOAD_CSV + '/' + nameCsv;
    const body = null;
    const header = ProjectConstants.returnHeaderBlank();
    return this.http.get(url, {headers: header, responseType: 'text'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }
}

